module.exports = __webpack_public_path__ + "img/about-us.d8a2c222.gif";